<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading">
          <table class="table table-hover table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Сотрудник</th>
              <th>Фиксированный</th>
              <th>Фактический</th>
              <th>Просчет</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, i) in records">
              <td>{{ i + 1 }}</td>
              <td>
                <p>({{ record.id }}) {{ record.name }}</p>
                <p><span class="badge mr-1" v-for="role in record.roles">{{ role.name_title }}</span></p>
              </td>
              <td>
                {{ $AllCurrencies[record.sortedDetails.salary_details.details.base_currency].currency }}:
                {{ record.sortedDetails.salary_details.details.base_salary }}
              </td>
              <td>
                <p>заявки <strong>RUB: {{ Math.round(salaryData[record.id].orders_sum) }}</strong></p>
                <p>заявки <strong>EUR: {{ Math.round(salaryData[record.id].orders_sum_eur) }}</strong></p>
                <p>процента <strong>EUR: {{ Math.round(salaryData[record.id].calculated_rate) }}</strong></p>
              </td>
              <td>
                <p><strong>{{ Math.round(salaryData[record.id].prospect_eur) }}</strong></p>
              </td>
              <td>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                    {{ $AllCurrencies[record.sortedDetails.salary_details.details.pay_currency_id].currency }}
                    </span>
                  </div>
                  <input type="number" class="form-control" v-model="paymentSum[record.id].sum">
                </div>
                <input type="text" v-model="paymentSum[record.id].comment" placeholder="Комментарий..."
                       class="form-control">
              </td>
              <td>
                <LoadingButton
                  title="Выплатить"
                  :loading="loadingBtn[record.id]"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => makePayment(record)"
                  className="btn btn-outline-success"
                />
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import moment from "moment/moment";

export default {
  components: {LoadingButton},
  componenst: {
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      records: [],
      paymentSum: {},
      loadingBtn: {},
      salaryData: {},
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  created() {
    this.getRecords();
  },
  methods: {
    async makePayment(record) {
      this.loadingBtn[record.id] = true;
      const {data} = await api.post('users/salary', {
        month: moment().set('date', 1).toDate(),
        userId: record.id,
        type_id: 3,
        salaryData: record.sortedDetails.salary_details.details,
        ordersData: this.salaryData[record.id],
        payData: {
          sum: this.paymentSum[record.id].sum,
          comment: this.paymentSum[record.id].comment,
          currency: record.sortedDetails.salary_details.details.pay_currency_id,
        }
      });
      this.loadingBtn[record.id] = false;
    },
    getTotalSum(record) {
      let salary = +record.sortedDetails.salary_details.details.base_salary;
      if (+record.sortedDetails.salary_details.details.base_currency !== +record.sortedDetails.salary_details.details.pay_currency_id) {
        salary = Math.round(salary * this.$AllCurrencies[record.sortedDetails.salary_details.details.base_currency].rate / this.$AllCurrencies[record.sortedDetails.salary_details.details.pay_currency_id].rate);
      }
      salary += Math.round(this.salaryData[record.id].prospect_eur / this.$AllCurrencies[record.sortedDetails.salary_details.details.pay_currency_id].rate);
      return salary;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/users/salaryp');
      const paymentSum = {};
      this.salaryData = data.salaryData;
      this.loadingBtn = data.records.reduce((acc, r) => {
        paymentSum[r.id] = {};
        paymentSum[r.id].sum = this.getTotalSum(r);
        paymentSum[r.id].comment = null;
        acc[r.id] = false;
        return acc;
      }, {})
      this.paymentSum = paymentSum;
      this.records = data.records;
      this.loading = false;
    }
  }
}

</script>
